import {FC} from "react";
import {Section, SectionHeading} from "../../../common/Section";
import {ButtonWithConfirmation} from "../../../common/ButtonWithConfirmation";
import {getNewsletterAdminApi, getSystemConfig} from "../../../System/systemConfig";
import {useMutation} from "@tanstack/react-query";
import {LoadingIndicatorContent} from "../../../common/LoadingIndicatorSpinner";

interface Props {

}

export const newsletterUserExportPath = () => `/client-admin/newsletter/user-export`;

export const NewsletterUserExport: FC<Props> = (props) => {

    const api = getNewsletterAdminApi();

    const exportMutation = useMutation({
        mutationFn: () => api.exportNewsletterUsersToCsv({clientId: String(getSystemConfig().clientId)}),
        
        onSuccess: (data) => {
            // Handle the CSV data, e.g., trigger a download
            const blob = new Blob([data], {type: 'text/csv'});
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'newsletter_users.csv';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        },
        onError: (error) => {
            // Handle error, e.g., show a notification
            alert('Fehler beim Exportieren der Newsletter-Abonnenten: ' + error);
        }
    })

    const onOK = () => {
        exportMutation.mutate();
    }

    return <Section>
        <SectionHeading>Newsletter User Export</SectionHeading>

        <ButtonWithConfirmation title="Export Newsletter Users"
                                color="danger"
                                message="Sind Sie sicher, dass Sie alle Newsletter-Abonnenten exportieren wollen? Dieser Vorgang dauert einige Minuten und erzeugt eine CSV-Daten mit den Nutzerdaten. "
                                onOK={onOK}
                                disabled={exportMutation.isPending}
        >
            <LoadingIndicatorContent isLoading={exportMutation.isPending}>Exportieren</LoadingIndicatorContent>
        </ButtonWithConfirmation>

    </Section>;
}